<script setup lang="ts">
import { ref } from 'vue';
import { ModalDialog } from '@hfc/ui-core';
import { Field, useForm } from 'vee-validate';
import { useMedicareConsentStore } from '@/consent/medicare/infrastructure/composition/useMedicareConsentStore';

interface EmitsInterface {
  (event: 'close'): void;
}

const emits = defineEmits<EmitsInterface>();

const { medicareConsentStore, medicareConsentState } = useMedicareConsentStore();
const { handleSubmit } = useForm();

const runValidations = handleSubmit(() => true);

const firstName = ref(medicareConsentState.value.application.contactInfo.firstName);
const lastName = ref(medicareConsentState.value.application.contactInfo.lastName);

const confirmEditName = async (): Promise<void> => {
  const localValid = await runValidations();
  if (localValid) {
    medicareConsentStore.updateContactInfo({ firstName: firstName.value.trim(), lastName: lastName.value.trim() });
    emits('close');
  }
};
</script>

<template>

  <ModalDialog @close="emits('close')" @confirm="confirmEditName" :show-confirm-button="true" :close-on-confirm="false" confirm-button="Confirm">
    <template #content>
      <div>
        <div class="flex flex-row gap-4 mb-4">
          <div class="flex flex-col w-full">
            <label class="font-medium mb-1 whitespace-nowrap text-sky-700 block">
              First Name <span class="font-serif">*</span>
            </label>
            <Field v-model="firstName" type="text" v-slot="{ field, errorMessage, meta }" name="medicare-first-name" rules="required|min:2|max:30">
              <input v-capitalized="field" v-bind="field" :class="{ ...meta }">
              <span class="error">{{ errorMessage }}</span>
            </Field>
          </div>
          <div class="flex flex-col w-full">
            <label class="font-medium mb-1 whitespace-nowrap text-sky-700 block">
              Last Name <span class="font-serif">*</span>
            </label>
            <Field v-model="lastName" type="text" v-slot="{ field, errorMessage, meta }" name="medicare-last-name" rules="required|min:2|max:30">
              <input v-capitalized="field" v-bind="field" :class="{ ...meta }">
              <span class="error">{{ errorMessage }}</span>
            </Field>
          </div>
        </div>
      </div>
    </template>
  </ModalDialog>
</template>
